export const ReactTableColumnProperties = Object.freeze({
  sortable: true,
  filterable: true,
  resizable: true,
  show: true,
});

export const ReactTableWrapperColumnProperties = Object.freeze({
  sortable: true,
  filterable: true,
  resizable: true,
  show: true,
  visibility: true, //this key is wrapper table
});

export const ReactTableWrapperAlignCenter = Object.freeze({
  style: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const ReactTableVerticalAlignCenter = Object.freeze({
  style: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
});

export const ReactTableWrapperCogColumnProperties = Object.freeze({
  resizable: false,
  width: 50,
  sortable: false,
  style: {
    ...ReactTableWrapperAlignCenter,
  },
});



// WEBPACK FOOTER //
// ./src/common/Constants/reactTable.js